module.exports = __webpack_public_path__ + "static/media/tempo-logo.6a70504f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/sections/tempo-logo.png
// module id = 116
// module chunks = 0